// extracted by mini-css-extract-plugin
export default {"card":"v6-z"};